import React, { useState } from 'react';

export default function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  return (
    <div className="border rounded p-4">
      <h3 className="text-lg font-semibold mb-2">Subscribe</h3>
      {submitted ? (
        <div className="text-green-600 text-sm">Thanks for subscribing.</div>
      ) : (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setSubmitted(true);
          }}
          className="space-y-2"
        >
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="w-full border rounded px-3 py-2"
          />
          <button type="submit" className="w-full bg-blue-600 text-white rounded px-3 py-2">
            Sign up
          </button>
        </form>
      )}
    </div>
  );
}
